import { render } from "./MyGroup.vue?vue&type=template&id=90145506&scoped=true&ts=true"
import script from "./MyGroup.vue?vue&type=script&lang=ts"
export * from "./MyGroup.vue?vue&type=script&lang=ts"

import "./MyGroup.vue?vue&type=style&index=0&id=90145506&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90145506"]])

export default __exports__